import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'

import { t } from 'translations'
import { TrackAction } from 'services/TrackAction'

const StartContactListConfirmationModal = ({ commandPending, changeListStatus }) => {
  const dispatch = useDispatch()
  const { disableTwilio } = useSelector(state => state.settings)

  const start = () => {
    // Track that user has started a contact list
    TrackAction('START_CONTACT_LIST')
    changeListStatus('START')
    dispatch(closeModal())
  }

  return (
    <BaseModal title="manager.contactLists.START_CONTACT_LIST_CONFIRMATION_MODAL" hideButtons showCostIcon={!disableTwilio}>
      <div className="mt-3">
        <Button className="btn btn-primary mr-2" type="submit" isSubmitting={commandPending} text={t(`manager.contactLists.START`)} onClick={start} />
        <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
          {t(`actions.CLOSE`)}
        </Button>
      </div>
    </BaseModal>
  )
}

export default StartContactListConfirmationModal
